var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "convertModal",
      staticClass: "modal fade",
      attrs: { role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c(
          "div",
          {
            staticClass: "modal-content",
            staticStyle: { position: "relative" }
          },
          [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [_vm._v(_vm._s(_vm.$t("surveyImport")))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("surveyImport")) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("DropZone", {
                  attrs: {
                    formId: "uploadModal" + _vm.uid,
                    url: _vm.dropzoneUrl
                  },
                  on: {
                    uploaded: _vm.onUploaded,
                    "file-added": function($event) {
                      _vm.isUploading = true
                    },
                    error: function($event) {
                      _vm.isUploading = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.dismiss }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnClose")))]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.isUploading
              ? _c(
                  "div",
                  { staticClass: "modal-overlay" },
                  [_c("Spinner", { attrs: { type: "secondary" } })],
                  1
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }